module.exports = {"credits":1000,"resource1":1000,"resource2":1000,"resource3":1000,"resource4":1000,"resource5":1000,"resource6":1000}


//////////////////
// WEBPACK FOOTER
// ./src/data/initialResources.json
// module id = 42
// module chunks = 0